import React from "react";
import PageHeader from "@/components/PageHeader";
import CtaBand from "@/components/CtaBand";
import Seo, { faqJsonLd } from "@/components/Seo";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { FAQS } from "@/lib/content";

const FAQPage = () => {
  return (
    <>
      <Seo
        title="FAQ — India EOR & Managed Teams | Bright EOR"
        description="Answers on EOR vs managed teams, dedicated employees, who chooses and manages staff, team leaders, pricing, replacements and setting up your own Indian entity."
        path="/faq"
        jsonLd={faqJsonLd(FAQS)}
      />
      <PageHeader
        eyebrow="FAQ"
        title="Questions before you begin."
        subtitle="Everything UK business owners typically ask about hiring India-based remote staff through Bright EOR."
      />
      <section className="py-20 lg:py-28" data-testid="faq-detail">
        <div className="mx-auto max-w-3xl px-6 md:px-10">
          <Accordion type="single" collapsible className="w-full">
            {FAQS.map((item, i) => (
              <AccordionItem key={i} value={`item-${i}`} className="border-slate-200" data-testid={`faq-detail-${i}`}>
                <AccordionTrigger className="text-left font-display text-[17px] font-medium text-navy hover:no-underline hover:text-aqua py-5">
                  {item.q}
                </AccordionTrigger>
                <AccordionContent className="text-[15px] text-slateink leading-relaxed pb-5">
                  {item.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </section>
      <CtaBand />
    </>
  );
};

export default FAQPage;
